import { z } from 'my-zod'

export const OutfitterCustomProductEnum = z.enum([
  'Kayak',
  'Bicycle',
  'Mucky Duck',
  'Archery',
  'Clay Shooting',
  'Bass Fishing',
  'Paddle Board',
  'Boat',
  'Canoe',
  'Jeep',
  'Jet Ski',
  'Dirt Bike',
  'Scooter',
  'Surfboard',
  'RV',
  'Equipment',
  'EHS'
])
export type OutfitterCustomProduct = z.infer<typeof OutfitterCustomProductEnum>
export const CustomProductOptions = Object.values(OutfitterCustomProductEnum.Values)
